export default __webpack_public_path__ + "static/media/david_rendon.d4de365d.png";